var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.4 17.6l-4-4.1c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l3.3 3.4 9.1-9.1c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-9.8 9.8c-.4.4-1 .4-1.4 0z"}));
}

Checkmark.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
